import { ReactNode, useState } from 'react'
import { FileOutlined } from '@ant-design/icons'
import { Popover, Tag } from 'antd'
import type { OverdueFeedbackItem } from '@/api/orderManage'
import styles from './style.module.scss'

type Props = {
  type: 'shipment' | 'proper'
  records?: OverdueFeedbackItem[]
  children: ReactNode
}

/**
 * 附件地址白名单校验：只允许站内相对路径和 http/https 绝对地址。
 * 反馈附件来自供应商填报，历史数据可能出现 javascript:、data: 等可执行协议，
 * 直接写进 <a href> 会形成 XSS / 跳转风险，这里统一拦截。
 */
export function isSafeFileUrl(fileUrl?: string | null): fileUrl is string {
  const url = (fileUrl ?? '').trim()
  if (!url) return false
  // 协议相对地址（//host/path）会跳出当前站点，一并拒绝
  if (url.startsWith('//')) return false
  if (url.startsWith('/')) return true
  try {
    // 交给 URL 解析器判定协议，可覆盖 java\nscript: 之类的绕过写法
    const { protocol } = new URL(url, window.location.origin)
    return protocol === 'http:' || protocol === 'https:'
  } catch {
    return false
  }
}

export default function OverdueFeedbackPopover({
  type,
  records,
  children,
}: Props) {
  const [open, setOpen] = useState(false)
  const list = records ?? []
  if (!list.length) return <>{children}</>
  const shipment = type === 'shipment'
  const label = shipment ? '发货超期' : '妥投超期'
  const content = (
    <div className={styles.content}>
      <div className={styles.title}>
        {label}反馈（{list.length}条）
      </div>
      <div className={styles.list}>
        {list.map((item, index) => (
          <div className={styles.item} key={`${item.createTime}-${index}`}>
            <div className={styles.meta}>
              <Tag color={shipment ? 'blue' : 'orange'}>{label}</Tag>
              <span>{item.createTime}</span>
            </div>
            <div>
              <span className={styles.field}>预计完成时间：</span>
              {item.expectFinishTime}
            </div>
            <div>
              <span className={styles.field}>反馈原因：</span>
              {item.reason}
            </div>
            <div className={styles.attachments}>
              <span className={styles.field}>附件：</span>
              {(item.attachments ?? []).length ? (
                (item.attachments ?? []).map((file) =>
                  isSafeFileUrl(file.fileUrl) ? (
                    <a
                      href={file.fileUrl}
                      target="_blank"
                      rel="noreferrer"
                      key={`${file.fileUrl}-${file.fileName}`}
                    >
                      <FileOutlined /> {file.fileName}
                    </a>
                  ) : (
                    <span
                      className={styles.invalidFile}
                      title="附件地址不合法，已禁止打开"
                      key={`${file.fileUrl}-${file.fileName}`}
                    >
                      <FileOutlined /> {file.fileName}（地址不合法）
                    </span>
                  ),
                )
              ) : (
                <span>-</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
  return (
    <Popover
      content={content}
      placement="bottomLeft"
      overlayClassName={styles.overlay}
      getPopupContainer={() => document.body}
      // 键盘用户通过 Tab 聚焦触发器后回车/空格触发 click 打开，浮层不会随焦点移出立即关闭，
      // 因而可以继续 Tab 进入浮层查看反馈明细和附件
      trigger={['hover', 'click']}
      open={open}
      onOpenChange={setOpen}
    >
      <button
        type="button"
        className={styles.trigger}
        aria-label={`查看${label}反馈，共 ${list.length} 条`}
        aria-expanded={open}
        onKeyDown={(event) => {
          if (event.key === 'Escape') setOpen(false)
        }}
      >
        {children}
      </button>
    </Popover>
  )
}
import { ReactNode, useState } from 'react'
import { FileOutlined } from '@ant-design/icons'
import { Popover, Tag } from 'antd'
import type { OverdueFeedbackItem } from '@/api/orderManage'
import styles from './style.module.scss'

type Props = {
  type: 'shipment' | 'proper'
  records?: OverdueFeedbackItem[]
  children: ReactNode
}

/**
 * 附件地址白名单校验：只允许站内相对路径和 http/https 绝对地址。
 * 反馈附件来自供应商填报，历史数据可能出现 javascript:、data: 等可执行协议，
 * 直接写进 <a href> 会形成 XSS / 跳转风险，这里统一拦截。
 */
export function isSafeFileUrl(fileUrl?: string | null): fileUrl is string {
  const url = (fileUrl ?? '').trim()
  if (!url) return false
  // 协议相对地址（//host/path）会跳出当前站点，一并拒绝
  if (url.startsWith('//')) return false
  if (url.startsWith('/')) return true
  try {
    // 交给 URL 解析器判定协议，可覆盖 java\nscript: 之类的绕过写法
    const { protocol } = new URL(url, window.location.origin)
    return protocol === 'http:' || protocol === 'https:'
  } catch {
    return false
  }
}

export default function OverdueFeedbackPopover({
  type,
  records,
  children,
}: Props) {
  const [open, setOpen] = useState(false)
  const list = records ?? []
  if (!list.length) return <>{children}</>
  const shipment = type === 'shipment'
  const label = shipment ? '发货超期' : '妥投超期'
  const content = (
    <div className={styles.content}>
      <div className={styles.title}>
        {label}反馈（{list.length}条）
      </div>
      <div className={styles.list}>
        {list.map((item, index) => (
          <div className={styles.item} key={`${item.createTime}-${index}`}>
            <div className={styles.meta}>
              <Tag color={shipment ? 'blue' : 'orange'}>{label}</Tag>
              <span>{item.createTime}</span>
            </div>
            <div>
              <span className={styles.field}>预计完成时间：</span>
              {item.expectFinishTime}
            </div>
            <div>
              <span className={styles.field}>反馈原因：</span>
              {item.reason}
            </div>
            <div className={styles.attachments}>
              <span className={styles.field}>附件：</span>
              {(item.attachments ?? []).length ? (
                (item.attachments ?? []).map((file) =>
                  isSafeFileUrl(file.fileUrl) ? (
                    <a
                      href={file.fileUrl}
                      target="_blank"
                      rel="noreferrer"
                      key={`${file.fileUrl}-${file.fileName}`}
                    >
                      <FileOutlined /> {file.fileName}
                    </a>
                  ) : (
                    <span
                      className={styles.invalidFile}
                      title="附件地址不合法，已禁止打开"
                      key={`${file.fileUrl}-${file.fileName}`}
                    >
                      <FileOutlined /> {file.fileName}（地址不合法）
                    </span>
                  ),
                )
              ) : (
                <span>-</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
  return (
    <Popover
      content={content}
      placement="bottomLeft"
      overlayClassName={styles.overlay}
      getPopupContainer={() => document.body}
      // 键盘用户通过 Tab 聚焦触发器后回车/空格触发 click 打开，浮层不会随焦点移出立即关闭，
      // 因而可以继续 Tab 进入浮层查看反馈明细和附件
      trigger={['hover', 'click']}
      open={open}
      onOpenChange={setOpen}
    >
      <button
        type="button"
        className={styles.trigger}
        aria-label={`查看${label}反馈，共 ${list.length} 条`}
        aria-expanded={open}
        onKeyDown={(event) => {
          if (event.key === 'Escape') setOpen(false)
        }}
      >
        {children}
      </button>
    </Popover>
  )
}
